import {
  ENV_ACCOUNT_ID,
  ENV_CREDENTIAL_SCOPE,
  ENV_EXPIRATION,
  ENV_KEY,
  ENV_SECRET,
  ENV_SESSION,
  fromEnv
} from "./chunk-2E2TCHT5.js";
import "./chunk-VEAA7R3K.js";
import "./chunk-U4QICZVS.js";
import "./chunk-NPVQYUJC.js";
export {
  ENV_ACCOUNT_ID,
  ENV_CREDENTIAL_SCOPE,
  ENV_EXPIRATION,
  ENV_KEY,
  ENV_SECRET,
  ENV_SESSION,
  fromEnv
};
//# sourceMappingURL=dist-es-DRZJXHTP.js.map